/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthSocialLink, NbAuthService, NbAuthResult } from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN } from '../constants';
import { NbToastrService } from '@nebular/theme';
import { AuthStore } from '../../../@core/root-store/auth-store/auth.store';
import { User } from '../../../@core/interfaces/common/users';

@Component({
  selector: 'ngx-register',
  styleUrls: ['./register.component.scss'],
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxRegisterComponent implements OnInit {

  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  isUsernameRequired: boolean = this.getConfigValue('forms.validation.username.required');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  redirectDelay: number = this.getConfigValue('forms.register.redirectDelay');
  showMessages: any = this.getConfigValue('forms.register.showMessages');
  strategy: string = this.getConfigValue('forms.register.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  login: User = undefined;

  registerForm: FormGroup;
  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    private fb: FormBuilder,
    protected router: Router,
    private toasterService: NbToastrService,
    private userAuthService: AuthStore) {
      this.userAuthService.getAuthenticatedUser()
        .subscribe(user => {
          this.login = user;
        });
    }

  get name() { return this.registerForm.get('name'); }
  get lastname() { return this.registerForm.get('lastname'); }
  get username() { return this.registerForm.get('username'); }
  get email() { return this.registerForm.get('email'); }
  get confirmemail() { return this.registerForm.get('confirmemail'); }

  ngOnInit(): void {
    const fullUsernameValidators = [];
    this.isUsernameRequired && fullUsernameValidators.push(Validators.required);

    const emailValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    this.isEmailRequired && emailValidators.push(Validators.required);

    this.registerForm = this.fb.group({
      name: this.fb.control('', []),
      lastname: this.fb.control('', []),
      username: this.fb.control('', [...fullUsernameValidators]),
      email: this.fb.control('', [...emailValidators]),
      confirmemail: this.fb.control('', [...emailValidators]),
    });
  }

  register(): void {
    this.user = {
      ...this.registerForm.value,
      host: window.location.origin,
      userId: this.login.id,
    };
    this.errors = this.messages = [];
    this.submitted = true;

    this.service.register(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.toasterService.success(this.messages[0], 'Creación de usuario');
        console.log(result.getMessages());


        const redirect = result.getRedirect();
        //this.toasterService.success(this.messages[0], 'Creación de usuario');
        console.log(result);
        if (redirect) {
          setTimeout(() => {
            return this.router.navigateByUrl(redirect);
          }, this.redirectDelay);
        }
       
      } else {
        this.errors = result.getErrors();
        // this.toasterService.danger(this.errors[0], "Error", {
        //   status: 'success',
        //   duration: 5000
        // });
        this.submitted = false;
       
        console.log(this.errors[0]);
      }
      this.cd.detectChanges();
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
